<mat-toolbar color="primary">
    <span>Protocols</span>
    <span class="toolbar-spacer"></span>
    <button mat-icon-button class="example-icon favorite-icon" aria-label="Example icon-button with heart icon">
        <mat-icon>search</mat-icon>
    </button>    
</mat-toolbar>
<div style="height:80vh;overflow-y: scroll;">
    <app-protocol-table [location]="location" [patient]="patient"></app-protocol-table>
</div>